import Banner from "./Banner";
import ServicesSection from "./Services-card";
import Cta from "./Cta";

const Services  = ({ language }) => {
  return (
    <>
      <Banner language={language}/>
      <ServicesSection language={language}/>
      <Cta language={language} />
    </>
  );
};

export default Services;
